import React, { useEffect, useState } from 'react';
import {
  Title,
  Modal,
  ModalHeader,
  ModalContent,
  Loader,
} from '@common/components';
import PropTypes from 'prop-types';
import loaderClasess from './LoaderModal.module.scss';

export default function LoaderModal({
  title = 'Cargando...',
  className,
  show = false,
}) {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
  }, [show]);

  return (
    <Modal
      onClose={() => setVisible(false)}
      visible={visible}
      className={className}
    >
      <ModalHeader>
        <Title type="h2">{title}</Title>
      </ModalHeader>
      <ModalContent className={loaderClasess.center}>
        <Loader size="big" />
      </ModalContent>
    </Modal>
  );
}

LoaderModal.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  show: PropTypes.bool,
};
